import { Link } from "react-router-dom";
import pawnaImage from "../../Images/pawana/TentStay/tnt1.jpg";
import trekImage from "../../Images/KorigadFort/kf1.jpg";
import villaImage from "../../Images/Resort.png";
import tp1 from "../../Images/Tour Packages/tp1.webp";
const categories = [
  {
    title: "Camping",
    description:
      "Find your lakeside escape at Pawna or Panshet, with stays for every kind of getaway.",
    image: pawnaImage,
    imageAlt: "Tents at a lakeside campsite",
    path: "/camping",
    action: "Explore camps",
  },
  {
    title: "Sahyadri Treks",
    description:
      "Explore forts, forest trails, waterfalls, and scenic mountain routes.",
    image: trekImage,
    imageAlt: "Scenic trail in the Sahyadri mountains",
    path: "/SahyadriTreks",
    action: "Find a trek",
  },
  {
    title: "Villas",
    description:
      "Planning a private getaway? Tell us what you have in mind and ask about available options.",
    image: villaImage,
    imageAlt: "Villa with a pool surrounded by greenery",
    path: "/villas",
    action: "Explore villas",
  },
  {
    title: "Tour Packages",
    description:
      "Have a destination in mind? Get in touch to plan a trip that suits your group.",
    image: tp1,
    imageAlt: "Travel destination in India",
    path: "/tour-packages",
    action: "Explore packages",
  },
];

const ExperienceCategories = () => (
  <section className="bg-white px-4 py-10 sm:px-6 sm:py-14">
    <div className="mx-auto max-w-6xl">
      <div className="mb-7 max-w-2xl sm:mb-9">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-blue-800">
          Find your next getaway
        </p>
        <h2 className="mt-2 text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">
          Choose your kind of adventure
        </h2>
        <p className="mt-3 text-base leading-7 text-slate-600">
          From a peaceful lakeside stay to a day on the trails, let’s find the
          right escape for you.
        </p>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:gap-6">
        {categories.map((category) => (
          <Link
            key={category.title}
            to={category.path}
            className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition duration-300 hover:-translate-y-1 hover:border-blue-200 hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-700"
          >
            <div className="aspect-[16/9] overflow-hidden bg-slate-100">
              <img
                src={category.image}
                alt={category.imageAlt}
                className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5 sm:p-6">
              <h3 className="text-xl font-bold text-slate-900 sm:text-2xl">
                {category.title}
              </h3>
              <p className="mt-2 min-h-12 text-sm leading-6 text-slate-600 sm:text-base">
                {category.description}
              </p>
              <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-blue-800">
                {category.action}
                <span
                  aria-hidden="true"
                  className="transition-transform group-hover:translate-x-1"
                >
                  →
                </span>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default ExperienceCategories;
